/*Tps-report*/
if (window.location.pathname.includes("reports/hotel")) {
    const options = {
        autoWidth: false,
        responsive: false,
        scrollY: 500,
        scrollX: true,
        columnDefs: getColumnDefs(),
        buttons: [
            { extend: "excel", text: '<i class="fas fa-file-download"></i>' }
        ]
    };

    function getColumnDefs() {
        let columnDefs = [
            {
                width: "10%",
                targets: "_all"
            },
            {
                render: function(data, type, row, meta) {
                    return meta.row + 1;
                },
                searchable: false,
                orderable: false,
                targets: 0
            },
            {
                render: function(data, type, row) {
                    return "<a href='/placement/edit/"+row.placement_id+"'>"+data+"</a>";
                },
                targets: 1
            },
            {
                render: function(data, type, row) {
                    return !data ? "--" : '<div class="row align-items-center text-left"><div class="col-2"><div class="color-box mr-2" style="background-color: '+data+'"></div></div><div class="col"><label class="m-0 small">'+row.card_name+'</label></div></div>';
                },
                targets: [2]
            },
            {
                render: function(data, type, row) {
                    return !data ? "--" : '<div class="row align-items-center text-left"><div class="col-2"><div class="color-box mr-2" style="background-color: '+data+'"></div></div><div class="col"><label class="m-0 small">'+row.virtual_card_name+'</label></div></div>';
                },
                targets: [3]
            },
            {
                render: function(data, type, row) {
                    return "$" + window.formatMoney(data === null ? 0 : data);
                },
                targets: 9
            },
            {
                render: function(data, type, row) {
                    if (data) return '<span style="display:none;">A</span><i class="fas fa-check"></i>';
                    else return '<span style="display:none;">B</span>';
                },
                targets: [10]
            },
            {
                render: function(data, type, row) {
                    var checked = data ? "checked" : "";
                    return "<input class='quickbooks' data-placement_id='"+row.placement_id+"' type='checkbox' "+checked+" disabled/>";
                },
                targets: [16]
            },
        ];

        app.$root.checklist_ids.forEach((id) => {
            columnDefs.push(
                {
                    render: function(data, type, row){
                        if (data == 1) {
                            return '<span style="display:none;">Yes</span><i class="fas fa-check"></i>';
                        } else if (data == 2) {
                            return '<sup>N</sup><span>/</span><sub>A</sub>';
                        } else {
                            return '<span style="display:none;">No</span><i class="fas fa-times"></i>';
                        }
                    },
                    targets: `col-checklist_${id}`,
                },
            )
        });

        return columnDefs;
    }

    $.each($(".data-table-hotel"), function() {
        $(this).data("options", options);
    });

    // for reconcilation
    function getReconcilationColumnDefs() {
        let reconciliationColumnDefs = [
            {
                width: "10%",
                targets: "_all"
            },
            {
                render: function(data, type, row, meta) {
                    return meta.row + 1; // Add numbering
                },
                targets: 0
            },
            {
                render: function(data, type, row) {
                    return "<a href='/placement/edit/"+row.placement_id+"'>"+data+"</a>";
                },
                targets: 1
            },
            {
                render: function(data, type, row) {
                    return !data ? "--" : '<div class="row align-items-center text-left"><div class="col-2"><div class="color-box mr-2" style="background-color: '+data+'"></div></div><div class="col"><label class="m-0 small">'+row.card_name+'</label></div></div>';
                },
                targets: [2]
            },
            {
                render: function(data, type, row) {
                    return !data ? "--" : '<div class="row align-items-center text-left"><div class="col-2"><div class="color-box mr-2" style="background-color: '+data+'"></div></div><div class="col"><label class="m-0 small">'+row.virtual_card_name+'</label></div></div>';
                },
                targets: [3]
            },
            {
                render: function(data, type, row) {
                    return "$" + window.formatMoney(data === null ? 0 : data);
                },
                targets: 9
            },
            {
                render: function(data, type, row) {
                    if (data) return '<span style="display:none;">A</span><i class="fas fa-check"></i>';
                    else return '<span style="display:none;">B</span>';
                },
                targets: [10]
            },
            {
                render: function(data, type, row) {
                    var checked = data ? "checked" : "";
                    return "<input class='quickbooks' data-placement_id='"+row.placement_id+"' type='checkbox' "+checked+" disabled/>";
                },
                targets: [15]
            },
            {
                render: function(data, type, row) {
                    return "<button type='button' class='btn btn-secondary btn-action' data-row='"+JSON.stringify(row)+"'>Action</button>"
                },
                targets: [16]
            },
            {
                render: function(data, type, row) {
                    return `<span class="d-none">${data || ''}</span><input class="migrate-hotel" type="checkbox" data-hotel_placement_id="${row.id}" ${!data ? 'disabled checked' : ''} />`;
                },
                targets: [17]
            },
        ];

        app.$root.checklist_ids.forEach((id) => {
            reconciliationColumnDefs.push(
                {
                    render: function(data, type, row){
                        if (data == 1) {
                            return '<span style="display:none;">Yes</span><i class="fas fa-check"></i>';
                        } else if (data == 2) {
                            return '<sup>N</sup><span>/</span><sub>A</sub>';
                        } else {
                            return '<span style="display:none;">No</span><i class="fas fa-times"></i>';
                        }
                    },
                    targets: `col-checklist_${id}`,
                },
            )
        });

        return reconciliationColumnDefs;
    }

    $.each($(".table-reconciliation"), function() {
        $(this).data("options", {
            ...options,
            columnDefs: getReconcilationColumnDefs()
        });
    });

    // Button action
  $('body').on('click', '.btn-action', function () {
    const t = $(this).closest(".data-table");
    const row = $(this).closest("tr")[0];
    const data = $(this).data("row");

    Swal.fire({
      title: 'Reconcilation Action',
      html: getHtmlModalView(data),
      icon: undefined,
      showCancelButton: true,
      confirmButtonColor: '#50C3CA',
      showConfirmButton: true,
      confirmButtonText: 'Completed',
      showLoaderOnConfirm: true,
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      heightAuto: false,
      width: 900,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !!Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      preConfirm: () => {
        try {
            $.ajax({
                url: "/api/hotel_placement_room/update",
                method: 'POST',
                data: {
                    id: data.room_id,
                    completed: 1,
                },
                success: function(response) {
                    t.DataTable().row(row).remove().draw();
                },
                error: function(error) {
                  console.error('Error updating invoiced status:', error);
                }
            });
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`)
        }
      },
      didOpen: () => {
        // checkboxes
        $(document).on('change', '#hotelForm input:checkbox', function () {
          if ($(this).attr('name') === 'quickbooks') {
            let isChecked = this.checked;
            let dataId = $(this).data('hp_id');
            $.ajax({
                url: "/api/hotel_placement/update",
                method: 'POST',
                data: {
                    quickbooks: isChecked,
                    id: dataId
                },
                success: function(response) {
                    response.message ? message(response.message) : message("Something went wrong.", 1);
                    t.DataTable().row(row).data({...data, quickbooks: isChecked}).draw();
                },
                error: function(error) {
                  console.error('Error updating invoiced status:', error);
                }
            });
            
          }
        });
      },
      didRender: () => {
      },
      willClose: () => {
      }
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire(
          'Successful!',
          'The placement has been reconciled sucessfully.',
          'success'
        );
      }
    })
  });

  function getHtmlModalView (data) {
    return `
      <div class="text-left mt-3" id="hotelForm">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-row mb-4">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Policyholder Name</label>
                  <div class="form-control-wrap text-lg">
                  ${data.policyholder ? data.policyholder : '-'}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-4">
              <div class="col">
                <div class="form-group">
                  <label class="form-control-wrap">Check Out Date</label>
                  <div class="form-control-wrap text-lg">
                    ${data.check_out_date ||'-'}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mb-3">
                <div class="col">
                    <label class="tps-checkbox">
                    <input type="checkbox" name="quickbooks"${data.quickbooks ? ' checked' : ''} class="live-skip" data-hp_id="${data.id}" />
                    <span class="checkmark"></span>
                    <span class="label">In Quickbooks</span>
                    </label>
                </div>
            </div>

            </div>

            <div class="col-12 col-md-6">
                <div class="form-row mb-4">
                    <div class="col">
                        <div class="form-group">
                        <label class="form-control-wrap">Which Card?</label>
                        <div class="form-control-wrap text-lg">
                            ${data.virtual_card_name ? data.virtual_card_name : '-'}
                        </div>
                        </div>
                    </div>
                </div>

                <div class="form-row mb-3">
                    <div class="col">
                        <div class="form-group">
                        <label class="form-control-wrap">Check In Date</label>
                        <div class="form-control-wrap text-lg">
                            ${data.check_in_date || '-'}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>`
  }

  $('body').on('change', '.migrate-hotel', function () {
    const card = $(this).parents('.card');
    const btnGroup = card.find('.card-header .dt-buttons.btn-group.flex-wrap');
    if (!card.find('.card-body .migrate-hotel:checked:not(:disabled)').length) {
        btnGroup.find('.btn-migrate').remove();
    } else if (!btnGroup.find('.btn-migrate').length) {
        btnGroup.prepend(`<button class="btn btn-secondary text-nowrap btn-migrate">Migrate Selected</button>`);
    }
  });

  $('body').on('click', '.btn-migrate', function () {
    const ids = [];
    const card = $(this).parents('.card');

    card.find('.card-body .migrate-hotel:checked:not(:disabled)').each(function() {
        ids.push($(this).data('hotel_placement_id'));
    });

    Swal.fire({
        title: "Migrate Hotel",
        html: `<div id="hotel-migrate">
            <form v-for="hotel_placement in hotel_placements" action="/api/hotel_placement/update" method="POST" class="text-left text-sm live-form card mb-3" data-model="placement.hotel_placements" :data-model_id="hotel_placement.id">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <span>{{hotel_placement.placement.policyholder.name}}</span>
                    <button type="button" data-toggle-alt="true"
                        class="btn btn-outline-white form-btn px-2 py-1 collapsed"
                        data-toggle="collapse"
                        :data-target="'#hotel-placement-' + hotel_placement.id"
                        aria-expanded="false"
                        :aria-controls="'hotel-placement-' + hotel_placement.id">
                    </button>
                </div>
                <div :id="'hotel-placement-' + hotel_placement.id" class="card-body collapse">
                    <v-hotel-placement :placement="hotel_placement.placement" :hotel_placement="hotel_placement" :is_legacy="false" :is_migrating="true"></v-hotel-placement>
                    <v-hidden v-model="hotel_placement.id" class="form-control d-none" name="id"></v-hidden>
                    <v-hidden v-model="hotel_placement.hotel_id" class="form-control d-none" name="hotel_id"></v-hidden>
                    <v-hidden v-model="hotel_placement.placement.id" class="form-control d-none" name="placement_id"></v-hidden>
                </div>
                <div class="card-footer"></div>
            </form>
        </div>`,
        icon: undefined,
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Migrate",
        showLoaderOnConfirm: true,
        reverseButtons: true,
        width: 1024,
        heightAuto: false,
        preConfirm: async () => {
            try {
                const result = await new Promise((resolve, reject) => {
                    $.ajax({
                        url: `/api/hotel_placement/migrate`,
                        method: "POST",
                        data: { ids },
                        dataType: "json",
                        success: response => resolve(response),
                        error: response => reject(response)
                    });
                });

                card.find('.card-body .migrate-hotel:checked:not(:disabled)').each(function() {
                    $(this).attr('disabled', true);
                });

                return result;
            } catch (e) {
                Swal.showValidationMessage(`There is something wrong!`);
            }
        },
        onRender: () => {
            Swal.showLoading();

            $.ajax({
                url: "/api/hotel_placement/read",
                method: 'POST',
                data: { ids },
                success: function(response) {
                    new Vue({
                        el: `#hotel-migrate`,
                        data: {
                            hotel_placements: [...response],
                            hotel_placement_clones: window.app_data.hotel_placement_clones,
                            models: window.app_models,
                            options: window.app_options,
                        },
                        methods: {
                            room_clone(id) {
                                this.$set(this.hotel_placement_clones, id, {
                                    "create_url":"/api/hotel_placement_room/create",
                                    "create_data": {
                                        "hotel_placement_id": id
                                    },
                                    "delete_url":"/api/hotel_placement_room/delete",
                                    "model": this.models.room
                                });

                                return "hotel_placement_clones." + id;
                            },
                            hotel_change (id) {
                                setTimeout(() => {
                                    $("[action='/api/hotel_placement/update'][data-model_id='"+id+"']")
                                    .find("[name='hotel_id']")
                                    .trigger("change");
                                }, 500);
                            },
                        },
                        computed: {
                            placement_hotels() {
                                return this.options.hotels;
                            },
                        }
                    });
                    Swal.hideLoading();
                },
                error: function(error) {
                    Swal.hideLoading();
                    Swal.showValidationMessage(`Error getting hotel data!`);
                    console.error('Error getting hotel data:', error);
                }
            });
        }
    }).then(result => {
        if (result.isConfirmed) {
            Swal.fire(
                "Submitted",
                "Hotel is migrated.",
                "success"
            );
        }
    });
  });

  $(window).on("dataTableInit.limelight", function(e, t) {
      t.on("order.dt search.dt", function() {
          t.column(0, { search: "applied", order: "applied" })
              .nodes()
              .each(function(cell, i) {
                  cell.innerHTML = i + 1;
              });
      }).draw();
  });

    // Search functionality for all tables
    $("[name='hotel_search']").on("keyup", function(){
        let val = $(this).val();
        $.each($(".data-table"), function(){
            $(this).DataTable().search(val).draw();
        });
    });

}




// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/hotel.js